/**
 * Configuration for jobs in this app.
 */
const jobiqoJobsConfig = require('./../jobs');
const R = require('ramda');

module.exports = R.mergeDeepRight(jobiqoJobsConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    GEO_INFO: {
      fixtures: [
        {
          label: 'Salt Lake City, UT, USA',
          location: { lat: 40.7608, lng: -111.8910 },
        },
        {
          label: 'West Valley City, UT, USA',
          location: { lat: 40.6916, lng: -112.0011 },
        },
        {
          label: 'West Jordan, UT, USA',
          location: { lat: 40.6097, lng: -111.9391 },
        },
        {
          label: 'Provo, UT, USA',
          location: { lat: 40.2338, lng: -111.6585 },
        },
        {
          label: 'Orem, UT, USA',
          location: { lat: 40.2969, lng: -111.6946 },
        },
        {
          label: 'Sandy, UT, USA',
          location: { lat: 40.56498, lng: -111.83897 },
        },
        {
          label: 'St. George, UT, USA',
          location: { lat: 37.0965, lng: -113.5684 },
        },
        {
          label: 'Ogden, UT, USA',
          location: { lat: 41.2230, lng: -111.9738 },
        },
      ]
    },
  },
});
